<n-slide-window 
    *ngIf="pageReady"  
    [(visible)]="windowVisible" 
    width="6rem" 
    [showMask]="true"
    (onHide)="close()">
    <n-header>
        <h1>
            {{i18n.detailTitle}}
        </h1>
    </n-header>
    <!-- 详情 -->
    <div class="upload-fail-detail">
        <ng-container *ngFor="let item of data">
            <div *ngIf="item.CMO_DETAIL_ATOM_STATE === CmoDetailAtomState.fail || item.CMO_DETAIL_ATOM_STATE === CmoDetailAtomState.pause">
                {{getErrorInfo | fn :item}}
            </div>
        </ng-container>
    </div>

    <n-footer>
        <button nButton 
            id="upload-fail-detail-close-btn" 
            [label]="i18n.closeBtn" 
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>